export default "__VITE_ASSET__3aTed0Qx__"